export default "/images/f181ad99021387fb22e49ee8187d77c0.avif";